import React from 'react';
import NoGames from './NoGames';
import { BeatLoader } from 'react-spinners';
import { useAppSelector } from '../store';
import GamesTable from './GamesTable';

export default function GamesList(): React.ReactNode {
  const { games, error, loading, loaded } = useAppSelector((state) => state.gamesReducer);

  if (error != null) {
    return (
      <div className="alert alert-warning" role="alert">
        <h2>We couldn’t load these games</h2>
        <p className="mb-0">
          Something went wrong on our end. Refresh the page to try again. If it keeps happening,
          give it a few minutes and come back.
        </p>
      </div>
    );
  }
  return (
    <div id="games-list">
      {loading || !loaded ? (
        <div className="cm-card cm-game p-2 p-lg-3 mb-3">
          <BeatLoader color="#ffffff" loading={true} />
        </div>
      ) : games == null || games.List.length == 0 ? (
        <NoGames></NoGames>
      ) : (
        <GamesTable></GamesTable>
      )}
    </div>
  );
}
